import React from 'react';
import { Box, Chip } from '@mui/material';

/**
 * Yes/No (or small option set) chips for bot confirmatory questions.
 * Click sends value to chat; label is shown as displayMessage when provided.
 */
export function QuickReplyPicker({
  items,
  onPick,
  disabled,
  botMessageColor = '#f5f5f5',
  botTextColor = '#000000',
  quickReplyTextColor = '#1976d2',
  quickReplyBorderColor = '#1976d2',
  quickReplyBackgroundColor = '#FFFFFF',
}) {
  if (!items?.length) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, my: 1, maxWidth: '100%' }}>
      {items.map((item, i) => {
        const label = item.label || item.value || `Option ${i + 1}`;
        return (
          <Chip
            key={`${label}-${i}`}
            label={label}
            onClick={() => {
              if (!disabled && onPick) {
                onPick(item);
              }
            }}
            variant="filled"
            size="large"
            disabled={disabled}
            sx={{
              cursor: disabled ? 'default' : 'pointer',
              backgroundColor: quickReplyBackgroundColor,
              color: quickReplyTextColor,
              border: `2px solid ${quickReplyBorderColor}`,
              fontWeight: 500,
              letterSpacing: '0.04em',
              '& .MuiChip-label': {
                letterSpacing: 'inherit',
              },
              '&:hover': {
                backgroundColor: quickReplyBackgroundColor,
                filter: 'brightness(0.94)',
              },
              '&.Mui-disabled': {
                opacity: 0.55,
                backgroundColor: quickReplyBackgroundColor,
                color: quickReplyTextColor,
              },
            }}
          />
        );
      })}
    </Box>
  );
}
